export const commentsData = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%20with%20warm%20lighting%20and%20soft%20neutral%20background%2C%20editorial%20style%2C%20natural%20expression&width=80&height=80&seq=avatar-01&orientation=squarish",
    name: "追剧小达人",
    date: "2026-07-30",
    rating: 5,
    drama: "《长安十二时辰》",
    content: "天美影视的画质真的没话说，4K高清看着太爽了，而且完全不卡顿。追了这么久剧，还是天美的体验最好，推荐给所有爱看剧的朋友！",
    likes: 1286,
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20with%20warm%20studio%20lighting%20and%20clean%20neutral%20background%2C%20editorial%20photography&width=80&height=80&seq=avatar-02&orientation=squarish",
    name: "影视爱好者老张",
    date: "2026-07-29",
    rating: 5,
    drama: "《狂飙》",
    content: "之前在其他平台追《狂飙》总是加载半天，换到天美影视之后流畅太多了。更新速度也快，基本上是全网同步，对追剧党来说太友好了。",
    likes: 953,
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20young%20woman%20portrait%20with%20soft%20natural%20lighting%20and%20minimal%20warm%20background%2C%20editorial%20style&width=80&height=80&seq=avatar-03&orientation=squarish",
    name: "夜色微凉",
    date: "2026-07-28",
    rating: 4,
    drama: "《繁花》",
    content: "资源很全，很多在其他地方找不到的老剧这里都有高清版本。界面简洁没有乱七八糟的广告弹窗，追剧体验真的很好。希望继续保持！",
    likes: 721,
  },
];

export const rankingData = [
  { rank: 1, title: "狂飙", heat: "9.8", genre: "刑侦 / 扫黑", update: "已完结", trend: "up", desc: "张译、张颂文主演年度爆款扫黑大剧" },
  { rank: 2, title: "繁花", heat: "9.7", genre: "都市 / 年代", update: "已完结", trend: "up", desc: "王家卫首部电视剧，胡歌领衔主演" },
  { rank: 3, title: "长安十二时辰", heat: "9.5", genre: "古装 / 悬疑", update: "已完结", trend: "stable", desc: "雷佳音、易烊千玺演绎盛唐危机" },
  { rank: 4, title: "庆余年 第二季", heat: "9.6", genre: "古装 / 权谋", update: "更新至36集", trend: "up", desc: "张若昀回归，范闲归来再掀风云" },
  { rank: 5, title: "漫长的季节", heat: "9.4", genre: "悬疑 / 生活", update: "已完结", trend: "stable", desc: "范伟、秦昊主演口碑悬疑力作" },
  { rank: 6, title: "三体", heat: "9.3", genre: "科幻 / 剧情", update: "已完结", trend: "down", desc: "刘慈欣原著改编，国产科幻里程碑" },
];

export const faqData = [
  {
    id: 1,
    question: "天美影视是否需要注册才能观看？",
    answer: "天美影视大部分剧集支持免注册直接观看，无需登录即可畅享高清追剧体验。部分独家内容可能需要简单注册，注册过程仅需手机号验证，完全免费。我们致力于为所有用户提供便捷、无障碍的观影服务。",
  },
  {
    id: 2,
    question: "天美影视的更新速度和画质如何？",
    answer: "天美影视与各大播出平台保持同步更新，热门剧集通常在首播后2小时内上线。所有剧集均提供1080P高清画质，热门剧集更支持4K超清分辨率。我们采用先进的视频编码和CDN加速技术，确保播放流畅不缓冲，即使高峰期也能稳定观看。",
  },
  {
    id: 3,
    question: "天美影视支持哪些设备观看？",
    answer: "天美影视全面支持PC网页端、手机浏览器、平板电脑等多种设备。页面采用响应式设计，自动适配不同屏幕尺寸，无论在家用电脑大屏还是通勤路上用手机，都能获得优质的观影体验。后续还将推出专属移动客户端。",
  },
  {
    id: 4,
    question: "天美影视的资源覆盖哪些类型？",
    answer: "天美影视电视剧大全涵盖国产剧、港剧、台剧、韩剧、日剧、美剧等多种类型。从热门新剧到经典老片，从都市情感到悬疑推理，从古装权谋到科幻冒险，各类题材应有尽有。我们持续扩充片库，确保用户能找到喜欢的剧集。",
  },
];

export const updatesData = [
  { id: 1, date: "2026-07-31", time: "14:30", title: "《庆余年 第二季》第37-38集已更新上线", type: "update", tag: "新集上线" },
  { id: 2, date: "2026-07-31", time: "10:00", title: "新剧《藏海花》全集资源已同步入库", type: "new", tag: "新剧入库" },
  { id: 3, date: "2026-07-30", time: "20:00", title: "《狂飙》4K修复版画质升级完成", type: "upgrade", tag: "画质升级" },
  { id: 4, date: "2026-07-30", time: "16:30", title: "《长安十二时辰》导演剪辑版上线", type: "new", tag: "特别版本" },
  { id: 5, date: "2026-07-29", time: "22:00", title: "服务器扩容完成，晚高峰播放更流畅", type: "notice", tag: "系统公告" },
  { id: 6, date: "2026-07-29", time: "15:00", title: "《三体》英文字幕版面向海外用户开放", type: "update", tag: "内容更新" },
  { id: 7, date: "2026-07-28", time: "18:00", title: "《漫长的季节》登陆天美影视热播榜", type: "new", tag: "热播推荐" },
  { id: 8, date: "2026-07-28", time: "09:00", title: "暑期追剧专题「盛夏剧好看」正式上线", type: "feature", tag: "专题上线" },
  { id: 9, date: "2026-07-27", time: "21:00", title: "播放器内核升级，加载速度提升30%", type: "upgrade", tag: "技术升级" },
];

export const indexData = [
  { id: 1, title: "热门国产剧", count: 326, icon: "ri-fire-line", desc: "最新最热的国产电视剧合集" },
  { id: 2, title: "经典港剧回顾", count: 185, icon: "ri-vip-crown-line", desc: "TVB经典剧集高清重制" },
  { id: 3, title: "高分悬疑剧场", count: 142, icon: "ri-search-eye-line", desc: "烧脑悬疑高分佳作精选" },
  { id: 4, title: "古装权谋大戏", count: 98, icon: "ri-sword-line", desc: "架空历史权谋斗争剧集" },
  { id: 5, title: "都市情感剧场", count: 210, icon: "ri-heart-line", desc: "现代都市爱情与生活剧" },
  { id: 6, title: "日韩热剧精选", count: 167, icon: "ri-global-line", desc: "日剧韩剧人气作品合集" },
  { id: 7, title: "科幻奇幻世界", count: 73, icon: "ri-rocket-line", desc: "科幻与奇幻题材剧集专题" },
];

export const cardsData = [
  {
    id: 1,
    title: "狂飙",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20crime%20drama%20scene%20with%20intense%20atmosphere%2C%20dark%20urban%20night%20setting%20with%20neon%20lights%2C%20dramatic%20lighting%2C%20film%20poster%20aesthetic&width=600&height=340&seq=drama-card-01&orientation=landscape",
    genre: "刑侦 / 扫黑",
    rating: "9.8",
    year: "2023",
    status: "已完结",
    desc: "年度现象级扫黑大剧，张译、张颂文巅峰对决",
  },
  {
    id: 2,
    title: "繁花",
    image: "https://readdy.ai/api/search-image?query=Shanghai%20Bund%20night%20scene%20with%20vintage%201990s%20aesthetic%2C%20golden%20warm%20lighting%2C%20elegant%20Chinese%20drama%20cinematic%20atmosphere%2C%20nostalgic%20film%20poster%20style&width=600&height=340&seq=drama-card-02&orientation=landscape",
    genre: "都市 / 年代",
    rating: "9.7",
    year: "2024",
    status: "已完结",
    desc: "王家卫首部电视剧，胡歌演绎上海传奇",
  },
  {
    id: 3,
    title: "庆余年 第二季",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20rich%20costumes%20and%20dramatic%20lighting%2C%20grand%20imperial%20architecture%2C%20cinematic%20film%20poster%20aesthetic%20with%20warm%20golden%20tones&width=600&height=340&seq=drama-card-03&orientation=landscape",
    genre: "古装 / 权谋",
    rating: "9.6",
    year: "2024",
    status: "更新中",
    desc: "张若昀回归，范闲归来再掀权谋风云",
  },
  {
    id: 4,
    title: "长安十二时辰",
    image: "https://readdy.ai/api/search-image?query=Tang%20Dynasty%20ancient%20Chinese%20city%20at%20dusk%20with%20lanterns%20and%20traditional%20architecture%2C%20dramatic%20cinematic%20lighting%2C%20historical%20epic%20film%20poster%20style&width=600&height=340&seq=drama-card-04&orientation=landscape",
    genre: "古装 / 悬疑",
    rating: "9.5",
    year: "2019",
    status: "已完结",
    desc: "雷佳音易烊千玺演绎盛唐危机24小时",
  },
  {
    id: 5,
    title: "三体",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20Chinese%20drama%20scene%20with%20cosmic%20background%20and%20mysterious%20atmosphere%2C%20deep%20space%20aesthetic%2C%20cinematic%20film%20poster%20style%20with%20cool%20and%20warm%20contrast&width=600&height=340&seq=drama-card-05&orientation=landscape",
    genre: "科幻 / 剧情",
    rating: "9.3",
    year: "2023",
    status: "已完结",
    desc: "刘慈欣科幻巨著改编，国产科幻里程碑",
  },
  {
    id: 6,
    title: "漫长的季节",
    image: "https://readdy.ai/api/search-image?query=Northeast%20China%20industrial%20town%20autumn%20scene%20with%20nostalgic%20warm%20tones%2C%20suspenseful%20atmosphere%2C%20cinematic%20drama%20film%20poster%20style%20with%20golden%20hour%20lighting&width=600&height=340&seq=drama-card-06&orientation=landscape",
    genre: "悬疑 / 生活",
    rating: "9.4",
    year: "2023",
    status: "已完结",
    desc: "范伟秦昊主演，跨越时空的口碑神作",
  },
  {
    id: 7,
    title: "藏海花",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20tomb%20adventure%20scene%20with%20dramatic%20lighting%2C%20desert%20and%20ancient%20ruins%2C%20cinematic%20film%20poster%20aesthetic%20with%20warm%20sand%20tones&width=600&height=340&seq=drama-card-07&orientation=landscape",
    genre: "冒险 / 悬疑",
    rating: "9.0",
    year: "2024",
    status: "已完结",
    desc: "南派三叔新作，张鲁一探秘藏海花世界",
  },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-4k-line",
    title: "超清画质",
    desc: "全站支持1080P高清，热门剧集提供4K超清分辨率。采用H.265编码技术，在保证画质的同时节省流量，让每一帧都清晰细腻。",
  },
  {
    id: 2,
    icon: "ri-flashlight-line",
    title: "极速加载",
    desc: "全球CDN加速节点覆盖，智能预加载技术让追剧不再等待。看剧零缓冲，拖动进度条秒响应，告别转圈等待的烦恼。",
  },
  {
    id: 3,
    icon: "ri-shield-check-line",
    title: "安全纯净",
    desc: "无弹窗广告、无恶意跳转、无强制下载。纯净的观影环境让您专注剧情，保护您的设备安全和隐私。不收集不必要的个人信息。",
  },
];

export const mediaData = [
  {
    id: 1,
    title: "《狂飙》幕后花絮",
    image: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20Chinese%20crime%20drama%20production%20with%20film%20crew%20and%20lighting%20equipment%2C%20cinematic%20atmosphere%2C%20warm%20professional%20lighting&width=560&height=315&seq=media-01&orientation=landscape",
    duration: "15:42",
    views: "128.6万",
    tag: "幕后花絮",
  },
  {
    id: 2,
    title: "2026暑期档追剧指南",
    image: "https://readdy.ai/api/search-image?query=Summer%20Chinese%20drama%20collection%20visual%20with%20bright%20warm%20aesthetic%2C%20collage%20of%20modern%20Chinese%20TV%20scenes%2C%20cinematic%20promotional%20style&width=560&height=315&seq=media-02&orientation=landscape",
    duration: "08:30",
    views: "96.3万",
    tag: "追剧指南",
  },
  {
    id: 3,
    title: "《繁花》名场面解析",
    image: "https://readdy.ai/api/search-image?query=Shanghai%20vintage%201990s%20drama%20iconic%20scene%20analysis%20with%20warm%20golden%20lighting%2C%20elegant%20Chinese%20cinema%20aesthetic%2C%20film%20study%20visual&width=560&height=315&seq=media-03&orientation=landscape",
    duration: "22:18",
    views: "185.2万",
    tag: "名场面",
  },
  {
    id: 4,
    title: "《庆余年》世界观全解读",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20world%20building%20concept%20art%20with%20imperial%20palace%20and%20martial%20arts%20elements%2C%20cinematic%20epic%20visual%20style%2C%20warm%20dramatic%20lighting&width=560&height=315&seq=media-04&orientation=landscape",
    duration: "18:55",
    views: "142.7万",
    tag: "深度解读",
  },
];

export const topicsData = [
  { id: 1, tag: "#狂飙大结局", heat: "982.6万", trend: "hot" },
  { id: 2, tag: "#庆余年第二季", heat: "876.3万", trend: "hot" },
  { id: 3, tag: "#繁花", heat: "765.8万", trend: "hot" },
  { id: 4, tag: "#2026暑期档", heat: "654.2万", trend: "rising" },
  { id: 5, tag: "#国产悬疑剧", heat: "543.1万", trend: "rising" },
  { id: 6, tag: "#古装权谋", heat: "498.7万", trend: "stable" },
  { id: 7, tag: "#科幻电视剧", heat: "432.5万", trend: "rising" },
  { id: 8, tag: "#高甜都市剧", heat: "389.3万", trend: "stable" },
  { id: 9, tag: "#经典港剧", heat: "345.6万", trend: "stable" },
  { id: 10, tag: "#4K追剧体验", heat: "298.4万", trend: "new" },
  { id: 11, tag: "#深夜剧场", heat: "267.1万", trend: "new" },
];

export const contactData = {
  title: "联系我们",
  subtitle: "商务合作 / 版权咨询 / 意见反馈",
  email: "contact@tianmei.tv",
  wechat: "天美影视官方",
  qq: "400-888-9999",
  desc: "如您有版权合作、内容推荐、商务洽谈等需求，欢迎通过以上方式与我们取得联系。我们的运营团队将在1-2个工作日内回复您的咨询。",
};

export const appData = {
  title: "随时随地 追剧无忧",
  subtitle: "天美影视移动端即将上线，精彩剧集随身看",
  features: ["离线缓存，无网也能看", "消息推送，更新不错过", "投屏功能，大屏更过瘾", "夜间模式，护眼追剧"],
  desc: "天美影视移动客户端即将推出，届时将支持iOS和Android双平台。敬请期待！",
};

export const carouselData = [
  {
    id: 1,
    title: "2026暑期档 · 热血追剧季",
    subtitle: "《庆余年第二季》《藏海花》《唐朝诡事录之西行》领衔暑期最强片单",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20drama%20summer%20season%20promotional%20visual%20with%20dramatic%20lighting%2C%20multiple%20characters%20silhouettes%2C%20warm%20golden%20and%20red%20cinematic%20tones%2C%20grand%20scale%20film%20poster%20aesthetic&width=1200&height=500&seq=carousel-01&orientation=landscape",
    tag: "暑期专题",
    link: "#cards",
  },
  {
    id: 2,
    title: "《狂飙》现象级爆款回顾",
    subtitle: "张译、张颂文演技巅峰，年度最高分扫黑大剧完整回顾",
    image: "https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20visual%20with%20two%20powerful%20male%20figures%20facing%20off%2C%20dark%20dramatic%20lighting%20with%20red%20accents%2C%20cinematic%20film%20poster%20aesthetic&width=1200&height=500&seq=carousel-02&orientation=landscape",
    tag: "经典回顾",
    link: "#cards",
  },
  {
    id: 3,
    title: "高分悬疑剧场 · 烧脑精选",
    subtitle: "《漫长的季节》《隐秘的角落》《白夜追凶》等高分悬疑力作合集",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20suspense%20drama%20visual%20with%20dark%20moody%20atmosphere%2C%20foggy%20urban%20landscape%2C%20dramatic%20cinematic%20lighting%2C%20thriller%20film%20poster%20aesthetic&width=1200&height=500&seq=carousel-03&orientation=landscape",
    tag: "悬疑精选",
    link: "#index",
  },
  {
    id: 4,
    title: "王家卫《繁花》影像美学",
    subtitle: "胡歌、马伊琍、唐嫣主演，上海90年代黄金岁月的视觉盛宴",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Shanghai%20night%20scene%20with%20vintage%201990s%20aesthetic%2C%20golden%20warm%20lighting%2C%20nostalgic%20Chinese%20cinema%20visual%20style%2C%20romantic%20atmosphere&width=1200&height=500&seq=carousel-04&orientation=landscape",
    tag: "经典美学",
    link: "#media",
  },
  {
    id: 5,
    title: "科幻之巅 ·《三体》全解析",
    subtitle: "刘慈欣原著改编，国产科幻电视剧的划时代之作深度解读",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20Chinese%20drama%20visual%20with%20cosmic%20phenomena%20and%20mysterious%20light%2C%20deep%20space%20aesthetic%2C%20cinematic%20film%20poster%20style%20with%20cool%20and%20warm%20contrast&width=1200&height=500&seq=carousel-05&orientation=landscape",
    tag: "科幻巨制",
    link: "#cards",
  },
  {
    id: 6,
    title: "古装权谋 · 庙堂风云录",
    subtitle: "《庆余年》《琅琊榜》《长安十二时辰》古装权谋大剧合集",
    image: "https://readdy.ai/api/search-image?query=Grand%20ancient%20Chinese%20imperial%20palace%20scene%20with%20dramatic%20clouds%20and%20golden%20lighting%2C%20epic%20historical%20drama%20visual%2C%20cinematic%20film%20poster%20aesthetic&width=1200&height=500&seq=carousel-06&orientation=landscape",
    tag: "古装权谋",
    link: "#index",
  },
];

export const aboutData = {
  title: "关于天美影视",
  paragraphs: [
    "天美影视是一个专注于高清电视剧在线观看的平台，致力于为广大追剧爱好者提供最新、最全、最流畅的观影体验。我们的片库涵盖国产剧、港剧、台剧、韩剧、日剧、美剧等丰富内容，从热门新剧到经典老片，满足不同观众的口味需求。",
    "平台采用先进的视频编码和CDN加速技术，确保1080P和4K超清画质的流畅播放。我们秉持纯净观影的理念，摒弃弹窗广告和恶意跳转，为用户营造一个安全、舒适的追剧环境。",
    "自上线以来，天美影视持续扩充内容资源、优化播放体验，已累计服务数百万追剧用户。未来我们将推出移动客户端，并持续拓展内容合作，让每一位用户都能在天美影视找到属于自己的精彩剧集。",
  ],
  stats: [
    { value: "5000+", label: "剧集资源" },
    { value: "300万+", label: "累计用户" },
    { value: "99.9%", label: "服务可用率" },
    { value: "24h", label: "内容同步" },
  ],
};